export default function(number) {
    return number && number.toLocaleString();
}
